module.exports = __webpack_public_path__ + "static/media/image1.7815f5b4.svg";